<template>
	<div class="privacy_page">
		<!-- ヘッダー -->
		<headerBar></headerBar>
		<div class="image_area" :style="{'background-image':'url(' + bgimage + ')'}"></div>
		<!-- コンテンツ -->
		<div class="contents_area">
			<div class="privacy_area">
				<div class="title">個人情報の取り扱いについて</div>
				<div class="comment">
					株式会社ビーブリッヂ（以下「当社」といいます）は、当社に個人情報をご提供される全ての皆さまのプライバシーを尊重し、
					管理に細心の注意を払い、取り扱います。<br><br>
					<div class="subtitle">個人情報の定義</div>
					個人情報とは、個人に関する情報であって、当該情報を構成する氏名、住所、メールアドレス、その他の記述等により個人を識別できるものをいいます。
					また、その情報のみでは識別できない場合でも、他の情報と容易に照合することができ、それにより個人を識別できるものも個人情報に含まれます。<br><br>
					<div class="subtitle">個人情報の利用目的</div>
					ご提供いただいた個人情報は以下の目的で利用し、利用目的を超えて利用することはありません。<br><br>
					（1）当社に対するご意見、お問合せに応対するため<br>
					（2）当社からのご連絡のため<br>
					（3）当社の採用に関する各種連絡・お知らせの配信のため<br>
					（4）その他ご本人からご指示またはご同意いただいた利用目的のため<br><br>
					<div class="subtitle">個人情報の第三者提供について</div>
					当社は、ご本人の同意がある場合又は法令に基づく場合を除き、取得した個人情報を第三者に提供することはありません。<br><br>
					<div class="subtitle">個人情報の取扱いの委託について</div>
					当社は、取得した個人情報の取扱いの全部又は一部を委託することがあります。<br><br>
					<div class="subtitle">統計データの利用について</div>
					当社は、提供を受けた個人情報をもとに、個人を特定できないよう加工した統計データを作成することがあります。
					個人を特定できない統計データについては、当社は何ら制限を受けることなく利用できるものとします。<br><br>
					<div class="subtitle">個人情報を入力するにあたっての注意事項</div>
					当社への個人情報のご提供は任意となっております。ただし、ご連絡先をご入力いただけない場合は、お問い合わせの応対で当社からご連絡することができませんので、あらかじめご了承下さい。<br><br>
					<div class="subtitle">個人情報の安全管理措置について</div>
					取得した個人情報については、漏洩、減失またはき損の防止と是正、その他個人情報の安全管理のために必要かつ適切な措置を講じ、応対品質向上を目的としてお問合せへの回答後も、取得した個人情報は当社内において適切に保管致します。
					このサイトは、SSL（Secure Socket Layer）による暗号化措置を講じています。<br><br>
					<div class="subtitle">開示対象個人情報の開示等および問い合わせ窓口について</div>
					ご本人からの求めにより、当社が保有する開示対象個人情報の利用目的の通知・開示・内容の訂正・追加または削除・利用の停止・消去および第三者への提供の停止（「開示等」といいます。）に応じます。 
					開示等に応ずる窓口は、以下の「お問い合わせ先」をご覧下さい。<br><br>
					<div class="subtitle">個人情報についてのお問い合わせ先</div>
					<div style="padding:10px 0 0 22px">
						〒802-0001<br>
						福岡県北九州市小倉北区浅野三丁目8番1号 AIMビル6F COMPASS小倉<br>
						TEL：093-555-0121<br>
						受付時間<br>
						平日：10:00〜17:00<br>
						個人情報保護管理者：橋本 哲郎<br><br>
					</div>
				</div>
			</div>
		</div>
		<!-- サイトマップ -->
		<sitemap></sitemap>
	</div>
</template>

<script>
import Vue from 'vue'
import headerBar from '@/components/headerBar.vue'
import sitemap from '@/components/map.vue'
export default {
	name: 'privacyPage',
	components: {
		'headerBar': headerBar,
		'sitemap': sitemap
	},
	data() {
		return {
			bgimage: require("@/assets/images/privacy_img.jpg")
		}
	},
	beforeRouteEnter(to, from ,next) {
		next(vm => {
			if (to.hash.match(/^#/)) {
				let anc = to.hash.replace(/^#/, '');
				vm.$scrollTo("#" + anc);
			} else {
				vm.$scrollTo("#app");
			}
		});
	},
	afterEach(to, from) {
		
	},
	watch: {
		'$route': function(n, o) {
			if (n.hash.match(/^#/)) {
				let anc = n.hash.replace(/^#/, '');
				this.$scrollTo("#" + anc);
			} else {
				this.$scrollTo("#app");
			}
		}
	}
}
</script>

<style lang="less" scoped>
.privacy_page {
	.image_area {
		width: 100%;
		height: 280px;
		background-size: cover;
		background-position: center;
	}
	
	.contents_area {
		padding: 60px 80px 80px 80px;
		
		.comment {
			.subtitle {
				font-weight: bold;
			}
		}
	}
	
	.title {
		font-size: 1.1rem;
		font-weight: bold;
		border-left: 8px solid #eb5f1a;
		border-bottom: 1px solid #eb5f1a;
		padding-left: 6px;
		margin-bottom: 10px;
	}
}

@media(max-width:420px) {
	.privacy_page {
		.contents_area {
			padding: 60px 28px;
		}
	}
}
</style>
